<template>
	<div>
		<a-modal okText="确定" cancelText="取消" @cancel="cancel" v-model="show" title="修改菜单" @ok="comfirm">
			<template v-if="record.data">
				<!-- 表单验证 -->
				<a-form ref="collectionForm" :form="form">
					
					<!-- 名称 -->
					<a-form-item label="id">
						<a-input disabled v-decorator="[
							'id',
							{
							  initialValue: record.data.id,
							  rules: [{ required: true, message: `请填写名称`, whitespace: true }],
							},
						  ]" />
					</a-form-item>

					<!-- 选中分类或者服务 -->
					<a-form-item label="菜单类型(关联商品或者关联分类)">
						<a-radio-group @change="gettype" v-decorator="[
							'type',
							{
							  initialValue:typename ,
							  rules: [{ required: true, message: `请填写`}],
							}
						]">
							<a-radio value="1">
								分类
							</a-radio>
							<a-radio value="2">
								服务
							</a-radio>
						</a-radio-group>
					</a-form-item>

					<template v-if="type == 1">
						<!-- 分类选择 -->
						<template v-if="record.classify">
							<a-form-item label="分类">
								<a-select @change="getselect" v-decorator="[
									'type_id',
									{ 
										initialValue: shopclass,
										rules: [{ required: true, message: '请填写分类'}] 
									},
								  ]">
									<a-select-opt-group v-for="(item,index) in record.classify" :label="item.name">
										  <a-select-option v-for="(items,indexs) in item.children"  :key="items.id">
											{{items.name}}
										  </a-select-option>
									</a-select-opt-group >
								</a-select>
							</a-form-item>
						</template>
						
					</template>
					<template v-else>
						<!-- 选择服务，级联选择器 -->
						<a-form-item label="服务">
							<a-cascader :options="record.shop" expand-trigger="hover" @change="getcascader" v-decorator="[
									'type_id',
									{
									  initialValue:cascader ,
									  rules: [{ required: true, message: `请填写`}],
									},
								  ]" />
						</a-form-item>
					</template>





					<!-- 名称 -->
					<a-form-item label="名称">
						<a-input v-decorator="[
							'name',
							{
							  initialValue: record.data.name,
							  rules: [{ required: true, message: `请填写名称`, whitespace: true }],
							},
						  ]" />
					</a-form-item>
					
					
					<template v-if="type == 2">
						<!-- 图片icon -->
						<a-form-item label="点击更换icon(68X68)">
							<img v-decorator="[
								'icon',
								{
								  initialValue: record.data.icon,
								  rules: [{ required: true, message: `请填写`, whitespace: true }],
								},
							  ]" style="width: 22%;height: 60%;cursor: pointer;" :src="record.data.icon" alt="" @click="openresources(1)">
						</a-form-item>
					</template>
					<template v-else>
						<!-- 图片icon -->
						<a-form-item label="点击更换icon(68X68)">
							<img v-decorator="[
								'icon',
								{
								  initialValue: record.data.icon,
								  rules: [{ required: true, message: `请填写`, whitespace: true }],
								},
							  ]" style="width: 22%;height: 60%;cursor: pointer;" :src="record.data.icon" alt="" @click="openresources(1)">
						</a-form-item>
						<!-- banner -->
						<template v-if="record.data.banner">
							<template v-if="record.data.banner[0]">
								<a-form-item label="点击更换banner(690X190)">
									<img v-decorator="[
										'banner',
										{
										  initialValue: record.data.banner,
										  rules: [{ required: true, message: `请填写`, whitespace: true }],
										},
									  ]" style="width: 22%;height: 60%;cursor: pointer;" :src="record.data.banner" alt="" @click="openresources(2)">
								</a-form-item>
							</template>
							
							<template v-else>
								<div style="width: 25%;height: 60%;border:1px dashed #CCCCCC;flex-direction: column;padding: 30px;" class="upload f-ajc" @click="openresources(2)">
									<a-icon type="plus" />
									<div class="ant-upload-text">
										上传图片
									</div>
								</div>
							</template>
						</template>

						
					</template>
					
				</a-form>
				<!-- 图片管理器 -->
				<resources ref="resources"  @getimgpath="getimgpath"></resources>
			</template>


		</a-modal>
	</div>
</template>

<script>
	import resources from "../resoureces.vue"
	export default {
		components: {
			resources
		},
		props: {
			record: Object
		},
		computed: {
			// 级联选中默认
			cascader() {
				if (this.record.shop) {
					let arr = []
					this.record.shop.map(item=>{
						
						if(item.value == this.record.data.category_top_id){
							arr.push(item.value)
							item.children.map(items=>{
								if(items.value == this.record.data.category_id){
									arr.push(items.value)
									items.children.map(itemss=>{
										if(itemss.value = this.record.data.type_id){
											arr.push(itemss.value)
										}
									})
								}
								
							})
						}
					})
					console.log(arr,"默认服务");
					return arr
				}
			},
			typename() {
				if (this.record.data) {
					let type = '1'
					this.record.data.type == '服务' ? type = '2' : type = '1'
					this.type = type
					return type
				}
			},
			// 菜单默认选中分类
			// 商品分类
			shopclass(){
				if(this.record.classify && this.record.data){
					let id = ""
					this.record.classify.map(item=>{
						console.log(this.record.data.category_top_id,"当前顶级分类");
						if(item.id == this.record.data.category_top_id){
							console.log(item,"二级分类");
							id = item.children.filter(items=>{
								return items.id == this.record.data.category_id
							})
						}
						
					})
					console.log(id,"分类id");
					return id[0].id
					
				}
			},
		},
		data() {
			return {
				show: false,
				type: '1',
				isresources: false,
				form: this.$form.createForm(this, {
					name: 'coordinated'
				}),
				witchbtn:1

			}
		},

		created() {

		},
		methods: {
			// 获取类型
			gettype(e) {
				// console.log(e, "类型");
				this.type = e.target.value.toString() 
				console.log(this.type, "类型");
			},
			// 获取商品
			getcascader(e) {
				console.log(e, "获取商品");
			},
			// 获取分类
			getselect(e) {
				console.log(e, "获取选中分类id");
			},
			// 打开图片管理器
			openresources(btn) {
				this.witchbtn  = btn
				// this.isresources = true
				this.$refs.resources.visibles = true
				// this.isresources = true
			},

			// 获取更改图片路径
			getimgpath(val) {
				// 收集数据集
				let payload = {
					val:val,
					witchbtn:this.witchbtn
				}
				this.$emit("changeimg", payload)
			},
			comfirm(e) {
				console.log(e);
				const form = this.$refs.collectionForm.form;
				form.validateFields((err, values) => {
					if (err) {
						return;
					}
					console.log('Received values of form: ', values);
					let isarr = values.type_id instanceof Array
					if(isarr){
						values.type_id = values.type_id[values.type_id.length-1]
					}else{
						values.type_id = values.type_id
					}
					
					let payload = ""
					if(this.type == '1'){
						payload = {
							type:values.type,
							name:values.name,
							type_id:values.type_id,
							banner:values.banner,
							id:values.id,
							icon:values.icon
						}
					}else{
						payload = {
							type:values.type,
							name:values.name,
							id:values.id,
							icon:values.icon,
							type_id:values.type_id,
							banner:'',
						}
					}
					// 执行提交方法
					this.$emit("modifynav", payload)
				});
			},
			cancel(e){
				let pagination = {
					pageSize:4,
					current:1,
					totalPage:0,
					total:0,
					keyword:"",
					platform:""
				}
				this.$emit("gettabledata",pagination)
			}
		}
	}
</script>

<style scoped lang="less">

</style>
